import Quill from 'quill'
import * as unicodeEmoji from 'unicode-emoji'
const Embed = Quill.import('blots/embed')

class EmojiBlot extends Embed {
  static create(value) {
    const node = super.create()
    if (typeof value === 'object') {
      EmojiBlot.buildSpan(value, node)
    } else if (typeof value === 'string') {
      const valueObj = unicodeEmoji
        .getEmojis()
        .find(emoji => emoji.description.split(' ').join('-') === value)

      if (valueObj) {
        EmojiBlot.buildSpan(
          {
            name: valueObj.description.split(' ').join('-'),
            unicode: valueObj.emoji
          },
          node
        )
      }
    }
    return node
  }

  static value(node) {
    return node.dataset.name
  }

  static buildSpan(value, node) {
    node.setAttribute('data-name', value.name)
    const emojiSpan = document.createElement('span')
    emojiSpan.classList.add(this.emojiClass)
    emojiSpan.classList.add(this.emojiPrefix + value.name)
    emojiSpan.innerText = value.unicode
    node.appendChild(emojiSpan)
  }

  static parseUnicode(string) {
    return string.split('-').map(str => parseInt(str, 16))
  }
}

EmojiBlot.blotName = 'emoji'
EmojiBlot.className = 'ql-emojiblot'
EmojiBlot.tagName = 'span'
EmojiBlot.emojiClass = 'ap'
EmojiBlot.emojiPrefix = 'ap-'

export default EmojiBlot
